// extracted by mini-css-extract-plugin
export default {"aldModal":"Modal_aldModal__3And6 ald-modal","modalTitleIcon":"Modal_modalTitleIcon__eGmpC","modalTitle":"Modal_modalTitle__JvsLa"};